import { render, staticRenderFns } from "./JAdvice.vue?vue&type=template&id=5b886805&scoped=true&"
import script from "./JAdvice.vue?vue&type=script&lang=ts&"
export * from "./JAdvice.vue?vue&type=script&lang=ts&"
import style1 from "./JAdvice.vue?vue&type=style&index=1&id=5b886805&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b886805",
  null
  
)

export default component.exports